import React from 'react';
import {
  UniversityListingContainer,
  fetchUniversityList,
  BEUniversity,
  UniversityData,
  universitySortByRank,
} from 'components/UniversityListing';
import { IconName } from '@admitkard/ccl/Icon';
import { NextPageContext } from 'next';

interface UniversityPageProps {
  finalUniversityList: UniversityData[];
  countryToSlugMapping: Record<string, IconName>;
}

const universityDataBDT = (backendUniversityList: BEUniversity[]) => {
  const slugToUniversityMatching: Record<string, UniversityData> = {};
  const countryToSlugMapping: Record<string, IconName> = {'All Countries' : 'flag'};
  for (const key in backendUniversityList) {
    const university = backendUniversityList[key];
    if (university.slug) {
      if(university.country&&university.country.name&&university.country.slug&&!countryToSlugMapping[university.country.name]){
        countryToSlugMapping[university.country.name] = university.country.slug as IconName;
      }
      if (slugToUniversityMatching[university.slug]) {
        if (university.rawCampus) {
          slugToUniversityMatching[university.slug].allCampusList.push(university.rawCampus);
        }
      } else {
        if (university.rawCampus) {
          const { rawCampus, ...rest } = university;
          const transformedUniversityListing = { ...rest, allCampusList: [university.rawCampus] };
          slugToUniversityMatching[university.slug] = transformedUniversityListing;
        }
      }
    }
  }
  return { filteredUniversityList: Object.values(slugToUniversityMatching), countryToSlugMapping: countryToSlugMapping};
};

export const getServerSideProps = async(context: NextPageContext) => {
  context.res?.setHeader('Cache-Control', 'public, stale-while-revalidate');
  const universityArray = await fetchUniversityList().then((response) => {
    return response;
  });
  const transformedUniversityData = universityDataBDT(universityArray);
  const countryToSlugMapping = transformedUniversityData.countryToSlugMapping;
  const finalUniversityList = transformedUniversityData.filteredUniversityList.sort(universitySortByRank);
  return { props: { finalUniversityList, countryToSlugMapping } };
};

const UniversityPage: React.FunctionComponent<UniversityPageProps> = (props) => {
  return <UniversityListingContainer countryToSlugMapping={props.countryToSlugMapping} universityList={props.finalUniversityList} />;
};

export default UniversityPage;
